import * as React from 'react';
import BottomNavigationAction from '@material-ui/core/BottomNavigationAction';

const CustomBottomNavigationAction = (props) => {
    return <BottomNavigationAction {...props} />;
};

export { CustomBottomNavigationAction as BottomNavigationAction };
